import { getCommonAnalytics } from "./common-analytics";

/**
 * Initialize GTM, dataLayer, and all analytics services
 * (Osano, Bloomreach, Salesforce, etc.).
 */
export function initAnalytics(initDatalayer?: Record<string, unknown>): void {
	getCommonAnalytics()?.init?.initAnalytics(initDatalayer);
}
